// get a string date '2022-02-23T14:09:22' and return it beautify -> '2022-02-23 14:09'
export const beautifyDate = (strDate) => {
	let date = strDate.split("T");
	let hour = date[1].slice(0, 5);
	date = date[0].split("-");
	let year = date[0];
	let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	let month = months[parseInt(date[1]) - 1];
	let day = parseInt(date[2], 10);
	let final = month + " " + day + ", " + year + " at " + hour;
	return final;
};

// get a string date '2022-02-23T14:09:22' and return how many days from today -> '2 days ago'
export const daysAgo = (strDate) => {
	let today = new Date();
	let created = new Date(strDate);
	let diffTime = Math.abs(created - today);
	diffTime = Math.round(diffTime / (1000 * 60 * 60 * 24));
	return diffTime + " days ago";
};
